import { ICellRendererParams } from 'ag-grid-community'

import { toDocumentStatus } from '@/const/artifact-status.types'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

import { DocumentStatusBadge } from '@/components/shared/document-status-badge/document-status-badge'

export const ArtifactAnalysisStatusCell = ({ data }: ICellRendererParams<ArtifactRow>) => {
  if (!data) return null

  const { status, error, dateUpdated } = data

  return (
    <div className='overflow-hidden'>
      <DocumentStatusBadge
        error={error}
        status={toDocumentStatus(status)}
        lastUpdated={dateUpdated}
      />
    </div>
  )
}
